import { IResponsibleUserData } from '../../../../types/responsibleUser.types';
import BordOneToneIcon from '../../BordOneToneIcon/BordOneToneIcon';
import MentionableUser, { ImentionableUser } from '../MentionableUser/MentionableUser';
import './MentionedUsers.scss';

const MentionedUsers = ({ mentionedUsers, handleRemoveUser, isDisabled, responsibleUsers }: IMentionedUsersProps) => {
  const handleRemoveUserClick = (user: ImentionableUser) => {
    const userIsResponsible = responsibleUsers?.some(responsibleUser => responsibleUser.userId === user.userId);
    if (isDisabled || userIsResponsible) return;
    handleRemoveUser(user);
  };

  if (isDisabled) return null;
  return (
    <div className="mentionedUsers">
      {mentionedUsers?.map((user, index) => {
        const userIsResponsible = responsibleUsers?.some(responsibleUser => responsibleUser.userId === user.userId);
        const disabledStyle = userIsResponsible || isDisabled;
        return (
          <div key={`${user.userId}${index}`} className="mentionedUser">
            <div className="mentionedUserSummary">
              <div className="mentionedUserEmail">@{user.email}</div>
              <div
                className={`${disabledStyle ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                onClick={() => handleRemoveUserClick(user)}
              >
                <BordOneToneIcon customWidth="10px" variant="xSquare" />
              </div>
            </div>
            <MentionableUser user={user} />
          </div>
        );
      })}
    </div>
  );
};

export default MentionedUsers;

export interface IMentionedUsersProps {
  mentionedUsers: ImentionableUser[];
  handleRemoveUser: (user: ImentionableUser) => void;
  isDisabled: boolean;
  responsibleUsers?: IResponsibleUserData[];
}
